import { defineStore } from 'pinia'

interface TextEditorState {
  colors: string[]
}

export const useTextEditorStore = defineStore('textEditor', {
  state: (): TextEditorState => ({
    colors: [],
  }),

  actions: {
    addColor(color: string) {
      console.log('addColor', color)
      // max 5 colors. if more than 5, remove the oldest color
      if (this.colors.length >= 5) {
        this.colors.pop() // Remove last color instead of first
      }
      this.colors.unshift(color) // Add new color to beginning
    },
    removeColor(color: string) {
      this.colors = this.colors.filter((c: string) => c !== color)
    },
    clearColors() {
      this.colors = []
    },
  },
  persist: {
    storage: piniaPluginPersistedstate.localStorage(),
  },

})
